// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8s-4";
export var collapsed = "_8s-1";
export var headerBar = "_8s-0";
export var leftHeaderContent = "_8s-3";
export var subjectContainer = "_8s-2";